import { Button } from 'components/button'
import { useDispatch } from 'react-redux'
import { STATICS } from 'statics'
import { setDrawer } from 'slices/drawer'
import { DRAWER_KEY } from 'app-constants'
import './style.scss'

export function Error() {
  const dispatch = useDispatch()

  function handleClose() {
    dispatch(setDrawer(DRAWER_KEY.NONE))
  }

  return (
    <div className='container-special-offer-error'>
      <div className='special-offer-content'>
        <div className='icon-info-error'>
          <STATICS.INFO_ERROR />
        </div>
        <p>
          Ocorreu um erro, tente novamente em alguns minutos ou entre em contato com a nossa Central
          de Atendimento
        </p>
      </div>
      <Button className='button' color='primary' onClick={handleClose}>
        Ok, entendi!
      </Button>
    </div>
  )
}
